import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ site }) {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-[#050505] border-t border-white/10"
    >
      <div className="px-5 sm:px-8 lg:px-12 pt-20 lg:pt-28 pb-10">
        <div className="grid grid-cols-12 gap-y-12 gap-x-6">
          
          <div className="col-span-12 lg:col-span-7">
            <p className="overline">/ Контакт</p>
            <a
              href={`mailto:${site.contact_email}`}
              data-testid="footer-email"
              className="block mt-6 font-display uppercase text-base sm:text-xl lg:text-3xl tracking-tight bbf-link break-all"
            >
              {site.contact_email}
            </a>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <p className="overline">/ Студия</p>
            <ul className="mt-6 space-y-3 text-white/65 text-sm">
              <li>Москва</li>
              <li>Санкт-Петербург</li>
              <li>Екатеринбург</li>
              <li>
                <a
                  href={`https://${site.contact_site}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[10px] uppercase tracking-[0.22em] text-white/50 bbf-link"
                >
                  {site.contact_site}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <p className="overline">/ Связаться</p>
            <ul className="mt-6 space-y-3 text-sm">
              <li>
                <a data-testid="footer-vimeo" href={site.contact_vimeo} target="_blank" rel="noreferrer" className="bbf-link text-white">
                  Vimeo
                </a>
              </li>
              <li>
                <a data-testid="footer-portfolio" href={`https://${site.contact_site}`} target="_blank" rel="noreferrer" className="bbf-link text-white">
                  Портфолио
                </a>
              </li>
              <li>
                <button
                  data-testid="footer-scroll-top"
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  className="bbf-link text-white"
                >
                  Наверх ↑
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 lg:mt-28 border-t border-white/10 pt-10 overflow-hidden">
          <h2
            aria-hidden="true"
            className="font-display uppercase tracking-[-0.05em] text-white/95 leading-[0.85] whitespace-nowrap"
            style={{ fontSize: "clamp(40px, 8.5vw, 130px)" }}
          >
            BIG BAG FILMS
          </h2>
          <div className="mt-10 flex flex-wrap items-center justify-between gap-4 font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/45">
            <span>© {new Date().getFullYear()} Big Bag Films Production</span>
            <span>Full Production of Emotions</span>
            <Link to="/privacy" data-testid="footer-privacy" className="bbf-link text-white/55 hover:text-white">
              Политика конфиденциальности
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}